import { render, staticRenderFns } from "./ID.vue?vue&type=template&id=b3eda110&"
import script from "./ID.vue?vue&type=script&lang=ts&"
export * from "./ID.vue?vue&type=script&lang=ts&"
import style0 from "./ID.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports